/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConditionItem } from './ConditionItem';
import {
    ConditionItemFromJSON,
    ConditionItemFromJSONTyped,
    ConditionItemToJSON,
    ConditionItemToJSONTyped,
} from './ConditionItem';

/**
 * 経済条件一覧レスポンス
 * @export
 * @interface ListGroupCompanyConditions200Response
 */
export interface ListGroupCompanyConditions200Response {
    /**
     * 
     * @type {Array<ConditionItem>}
     * @memberof ListGroupCompanyConditions200Response
     */
    conditions: Array<ConditionItem>;
}

/**
 * Check if a given object implements the ListGroupCompanyConditions200Response interface.
 */
export function instanceOfListGroupCompanyConditions200Response(value: object): value is ListGroupCompanyConditions200Response {
    if (!('conditions' in value) || value['conditions'] === undefined) return false;
    return true;
}

export function ListGroupCompanyConditions200ResponseFromJSON(json: any): ListGroupCompanyConditions200Response {
    return ListGroupCompanyConditions200ResponseFromJSONTyped(json, false);
}

export function ListGroupCompanyConditions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListGroupCompanyConditions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'conditions': ((json['conditions'] as Array<any>).map(ConditionItemFromJSON)),
    };
}

export function ListGroupCompanyConditions200ResponseToJSON(json: any): ListGroupCompanyConditions200Response {
    return ListGroupCompanyConditions200ResponseToJSONTyped(json, false);
}

export function ListGroupCompanyConditions200ResponseToJSONTyped(value?: ListGroupCompanyConditions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'conditions': ((value['conditions'] as Array<any>).map(ConditionItemToJSON)),
    };
}

